import type { ComponentPropsWithRef } from 'react';

import { PRICE_LIST_URL } from '@bank/utils';
import { Link } from '@storebrand-digital/pretzel';

import type { Language } from '../language';

const opensInNewTab = {
  no: 'åpnes i ny fane',
  en: 'opens in new tab',
} satisfies Record<Language, string>;

export interface PriceListLinkProps extends Omit<
  ComponentPropsWithRef<'a'>,
  'href' | 'children' | 'target' | 'rel'
> {
  linkText: string;
  locale: Language;
}

/**
 * External link to the Storebrand bank price list. Opens in a new tab and
 * renders an external-link icon plus visually-hidden "opens in new tab" text
 * for screen readers. The URL is fixed; callers only provide the link text.
 */
export const PriceListLink = ({
  linkText,
  locale,
  ...rest
}: PriceListLinkProps) => {
  return (
    <Link
      href={PRICE_LIST_URL}
      target="_blank"
      rel="noopener noreferrer"
      {...rest}
    >
      {linkText}
      <span className="sr-only"> {opensInNewTab[locale]}</span>
    </Link>
  );
};
